import { generateId } from "./id";
import { CHECKLIST_STATUS, buildDefaultItens } from "./checklistTemplate";
import { createEmptyAvarias } from "./avariaModel";

/**
 * Cria um novo checklist em branco.
 * workshopId identifica a oficina dona do checklist — é o campo usado
 * pelo painel central para filtrar/monitorar dados por oficina.
 */
export function createEmptyChecklist(workshopId, segmento) {
  const now = new Date().toISOString();
  return {
    id: generateId("chk"),
    workshopId,
    createdAt: now,
    updatedAt: now,
    status: CHECKLIST_STATUS.RASCUNHO,
    clienteId: null,
    veiculoId: null,
    cliente: {
      nome: "",
      telefone: "",
    },
    veiculo: {
      placa: "",
      marca: "",
      modelo: "",
      ano: "",
      km: "",
      // Fase 3 (biblioteca de veículos 3D): id do modelo 3D escolhido para
      // este checklist. Vazio = usa o modelo padrão automaticamente (ver
      // getModeloById em vehicleModels.js) -- checklists já existentes,
      // criados antes deste campo existir, continuam funcionando iguais.
      modelo3dId: "",
    },
    mecanicoResponsavel: "",
    // AUD-B: os itens JA NASCEM do segmento da oficina (carro ou moto).
    // Nao gravamos um campo `segmento` no checklist de proposito: o backend
    // nao tem coluna para ele (ver routes/checklist.py, que persiste apenas
    // placa/marca/modelo/ano/km) e um campo que nao sobrevive ao save e
    // exatamente o defeito que o modelo3dId tem hoje. A estrutura fica
    // congelada nos proprios itens, que SAO persistidos.
    itens: buildDefaultItens(segmento),
    avarias: createEmptyAvarias(),
    observacoesGerais: "",
    assinaturaCliente: null,
    assinaturaMecanico: null,
    aprovadoEm: null,
  };
}
